import { apiClient } from "@apis/apiClient";
import apiUtils from "@apis/apiUtils";


/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  getBeaconById(serial: any) {
    return apiClient.get(`/rest/infrastructure/serial/${serial}`);
  },
  getById(id: any) {
    return apiClient.get(`/rest/infrastructure/${id}`);
  },
  findAll(params: any) {
    return apiClient.get("/rest/infrastructure/", { params: params });
  },
  search(params: any) {
    return apiClient.post(`/rest/infrastructure/search`, params, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },
  performOperation(orgId: any, data: any) {
    return apiClient.put(
      apiUtils.buildParamsListURI("/rest/infrastructure/bulkRegister", {
        orgId: orgId,
      }),
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },
  update(id: any, data: any) {
    return apiClient.put(`/rest/infrastructure/${id}`, data, {
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
    });
  },

  getRandomUniqueSecret() {
    return apiClient.get("/rest/infrastructure/generateSecret", {
      headers: {
        "Content-type": "application/json",
        Accept: "application/json",
      },
    });
  },

  getRandomUniqueSerial() {
    return apiClient.get("/rest/infrastructure/generateSerial");
  },
};
